import Vue from 'vue';
import VueI18nManager from 'vue-i18n-manager';
import store from '@/store';
import router from '@/router';
import {
    GET_TRANSLATIONS
} from '@/store/action-types';

import 'vue-airbnb-style-datepicker/dist/vue-airbnb-style-datepicker.min.css';
import AirbnbStyleDatepicker from 'vue-airbnb-style-datepicker';



const proxy = {
    getTranslation: async () => {
        const response = await store.dispatch(`setting/${GET_TRANSLATIONS}`);
        const datepickerOptions = {
            colors: {
                selected: '#272727',
                inRange: '#f7f7f7',
                selectedText: '#9a9a9a',
                text: '#9a9a9a',
                inRangeBorder: 'transparent',
                disabled: '#fed700',
                hoveredInRange: '#f7f7f7'
            },
            daysShort: [response['daysShort.0'], response['daysShort.1'], response['daysShort.2'], response['daysShort.3'], response['daysShort.4'], response['daysShort.5'], response['daysShort.6']],
            days: [response['days.0'], response['days.1'], response['days.2'], response['days.3'], response['days.4'], response['days.5'], response['days.6']],
            monthNames: [
                response['monthNames.0'],
                response['monthNames.1'],
                response['monthNames.2'],
                response['monthNames.3'],
                response['monthNames.4'],
                response['monthNames.5'],
                response['monthNames.6'],
                response['monthNames.7'],
                response['monthNames.8'],
                response['monthNames.9'],
                response['monthNames.10'],
                response['monthNames.11']
            ],
        };
        Vue.use(AirbnbStyleDatepicker, datepickerOptions);

        return response;
    }
};


Vue.use(VueI18nManager, {
    store,
    router,
    proxy,
    config: {
        defaultCode: 'ua-UA',
        languages: [
            {
                name: 'Ukranian',
                title: 'Ua.',
                key: 'uk',
                code: 'ua-UA',
                urlPrefix: 'uk',
                translationKey: 'uk'
            },
            {
                name: 'Russian',
                title: 'Rus.',
                key: 'ru',
                code: 'ru-RU',
                urlPrefix: 'ru',
                translationKey: 'ru',
            },
            // {
            //     name: 'English',
            //     title: 'Eng.',
            //     key: 'eng',
            //     code: 'en-US',
            //     urlPrefix: 'en',
            //     translationKey: 'en'
            // },
        ],
        translations: proxy,
    },
});
